import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function BubbleCheckButton({ task, onComplete }) {
  const [showPop, setShowPop] = useState(false);
  const [isCompleting, setIsCompleting] = useState(false);

  const handleComplete = async () => {
    if (isCompleting) return;

    setIsCompleting(true);
    setShowPop(true);

    try {
      await axios.patch(`${API}/tasks/${task.id}`, {
        completed: true,
      }, { withCredentials: true });

      // Wait for animation to complete
      setTimeout(() => {
        toast.success('Task completed!');
        if (onComplete) onComplete();
      }, 550);
    } catch (error) {
      console.error('Error completing task:', error);
      toast.error('Failed to complete task');
      setIsCompleting(false);
      setShowPop(false);
    }
  };

  return (
    <button
      onClick={handleComplete}
      disabled={isCompleting}
      className="relative inline-flex items-center justify-center w-10 h-10 rounded-full bg-white shadow-[inset_0_2px_0_rgba(255,255,255,0.7)] ring-2 ring-slate-400 hover:ring-primary/50 hover:shadow-[0_8px_20px_rgba(15,181,167,0.15)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 active:scale-[0.97] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      aria-label="Complete task"
      data-testid="task-complete-bubble-button"
    >
      <Check className="w-5 h-5 text-[hsl(var(--primary))]" />
      <AnimatePresence>
        {showPop && (
          <motion.div
            initial={{ scale: 0.8, opacity: 0.8, filter: 'blur(0px)' }}
            animate={{
              scale: [0.8, 1.15, 0.9, 1],
              opacity: [0.8, 1, 0.9, 0],
              filter: ['blur(0px)', 'blur(1px)', 'blur(2px)', 'blur(3px)'],
            }}
            transition={{
              duration: 0.55,
              times: [0, 0.35, 0.6, 1],
              ease: 'easeOut',
            }}
            className="pointer-events-none absolute inset-0 rounded-full"
            data-testid="bubble-pop-anim"
          >
            <span className="absolute inset-0 rounded-full ring-2 ring-[hsl(var(--bubble-mint))]/50" />
            <span className="absolute inset-0 rounded-full shadow-[0_0_0_6px_rgba(15,181,167,0.08)]" />
          </motion.div>
        )}
      </AnimatePresence>
    </button>
  );
}
